import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const cateringPackageBaseEndpoint = ENDPOINTS.CATERINGPACKAGE;

// Event API using Catering Package endpoints
export const eventApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["cateringPackageType"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getEvents: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${cateringPackageBaseEndpoint}`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => {
          // Transform the paginated response to match expected structure
          return {
            data: response.data || [],
            pagination: {
              current_page: response.current_page,
              last_page: response.last_page,
              per_page: response.per_page,
              total: response.total,
              from: response.from,
              to: response.to
            },
            statistics: {
              active: response.active || 0,
              inactive: response.inactive || 0
            }
          };
        },
        providesTags: () => [{ type: "cateringPackageType" }],
      }),

      addEvent: builder.mutation({
        query: (requestData) => ({
          url: `${cateringPackageBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "cateringPackageType" }],
      }),
      updateEvent: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${cateringPackageBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "cateringPackageType" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
    useGetEventsQuery,
    useAddEventMutation,
    useUpdateEventMutation,
} = eventApi;
